import axios from "./axiosConfig";
//it was not suppose to a action. It is simple service
export const getQuizResult = (slug, courseId) => {
    return axios
        .get(`/api/v1/quizResult/${slug}?courseId=${courseId}`)
        .then((response) => {
            // handle success
            let data = response.data;
            return data;
        })
        .catch((error) => {
            const errorObj = error.response?.data || { message: 'An unknown error occurred' };
            return { error: errorObj };
        });
};

export function getAllQuizResults() {
    return axios
        .get("/api/v1/quiz/results")
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            const errorObj = error.response?.data || { message: 'An unknown error occurred' };
            return { error: errorObj };
        });
}

export function getSolution({ uniqueId, questionId }) {
    const endpoint = uniqueId
        ? `/api/v1/question/solution?uniqueId=${uniqueId}`
        : `/api/v1/question/solution?questionId=${questionId}`;
    return axios
        .get(endpoint)
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            const errorObj = error.response?.data || { message: 'An unknown error occurred' };
            return { error: errorObj };
        });
}
